import React from 'react';
import { SkeletonComponent } from '@design-system';

export const WorksiteRecapSkeleton: React.FC = () => {
    return (
        <div>
            {[...Array(3)].map((_, index) => (
                <SkeletonComponent
                    key={index}
                    count={1}
                    style={{
                        height: '176px',
                        width: '100%',
                        margin: '0',
                        borderRadius: '18px',
                        display: 'block'
                    }}
                />
            ))}
        </div>
    );
};
